export default function AssetAdminSettingsDialogController(
  $q,
  $scope,

  ssDialogService,
  alerts,
  loaderService,
  assetDataService,
  assetSharedModelService,
  editAssetTypeDialog
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleExpandSettingsSection = _handleExpandSettingsSection;
  vm.handleShowAddAssetTypeClick = _handleShowAddAssetTypeClick;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initEventListeners();
  }

  // Expand / Collapse;
  function _handleExpandSettingsSection($event, section) {
    vm[`${section}IsExpanded`] = !vm[`${section}IsExpanded`];
  }

  function _handleShowAddAssetTypeClick($event) {
    const _assetType = { customerAssetTypeId: 0 };
    assetDataService.getAssetTypeDefaults().then((response) => {
      _assetType.assetDataType = response.data.assetDataType;
      _assetType.assetCriticality = response.data.assetCriticality;
      _assetType.assetDataUse = response.data.assetDataUse;

      ssDialogService.dialogs.assetAdmin.editAssetTypeDialog = ssDialogService.alert(
        editAssetTypeDialog.getOptions($event, {
          assetType: _assetType,
          assetCriticalities: assetSharedModelService.AssetCriticalities,
          assetDataTypes: assetSharedModelService.AssetDataTypes,
          assetDataUses: assetSharedModelService.AssetDataUses,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.assetAdmin.editAssetTypeDialog);
    });
  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.assetAdmin.assetAdminSettingsDialog);
  }

  function _initEventListeners() {
    $scope.$on('refreshAssetTypes', _refreshAssetTypes);
    $scope.$on('refreshControlTypesOfRiskType', _refreshAssetTypes);
    $scope.$on('refreshAssetTypeSync', (event, payload) => {
      console.log(payload);
      // _refreshAssetSync(payload.assetType.customerAssetTypeId);
      loaderService.showViewLoader = false;
    });
    $scope.$on('pra_asset-type-deleted', (event, payload) => {
      console.log(payload);
      vm.assetTypes = vm.assetTypes.filter(
        assetType => assetType.customerAssetTypeId !== payload.customerAssetTypeId
      );
    });
  }

  function _refreshAssetSync(customerAssetTypeId) {
    loaderService.showViewLoader = true;
    const dfdItem = $q.defer();
    assetDataService.isCustomerAssetTypeInSync(customerAssetTypeId).then((getAssetTypeSyncResponse) => {
      // vm.assetTypes = getAssetTypesResponse.data.result.map((assetType) => {
      //   const myAssetType = assetSharedModelService.AssetTypes.find(
      //     currAssetType => currAssetType.customerAssetTypeId === assetType.customerAssetTypeId
      //   );
      //   let count = 0;
      //   if (myAssetType) {
      //     count = myAssetType.customerAssetCount;
      //   }
      //   return {
      //     ...assetType,
      //     instanceCount: count,
      //   };
      // });
      // angular.forEach(vm.assetTypes, (assetType) => {
      //   _initCriticality(assetType);
      // });
      // dfdItem.resolve();
    }).finally(() => {
      loaderService.showViewLoader = false;
    });

    return dfdItem.promise;
  }

  function _refreshAssetTypes() {
    loaderService.showViewLoader = true;
    const dfdItem = $q.defer();
    assetDataService.getAssetTypes().then((getAssetTypesResponse) => {
      vm.assetTypes = getAssetTypesResponse.data.result.map((assetType) => {
        const myAssetType = assetSharedModelService.AssetTypes.find(
          currAssetType => currAssetType.customerAssetTypeId === assetType.customerAssetTypeId
        );
        let count = 0;
        if (myAssetType) {
          count = myAssetType.customerAssetCount;
        }
        return {
          ...assetType,
          instanceCount: count,
        };
      });
      angular.forEach(vm.assetTypes, (assetType) => {
        assetType.isExpanded = false;
        _initCriticality(assetType);
      });
      dfdItem.resolve();
    }).finally(() => {
      loaderService.showViewLoader = false;
    });

    return dfdItem.promise;
  }

  function _initCriticality(assetType) {
    if (assetType.assetCriticalityId) {
      const classMappings = {
        1: 'status-tier-bar--terrible',
        2: 'status-tier-bar--bad',
        3: 'status-tier-bar--caution',
        4: 'status-tier-bar--good',
        5: 'status-tier-bar--great',
      };
      assetType.criticalityCssClass = classMappings[assetType.assetCriticalityId];
      if (!assetType.assetCriticality) {
        assetType.assetCriticality = assetSharedModelService.AssetCriticalities.find(
          assetCriticality => assetCriticality.assetCriticalityId === vm.assetType.assetCriticalityId
        );
      }
    }
  }
}

AssetAdminSettingsDialogController.$inject = [
  '$q',
  '$scope',
  'ssDialogService',
  'alerts',
  'loaderService',
  'assetDataService',
  'assetSharedModelService',
  'editAssetTypeDialog',
];
